<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }" v-if="!menuID">
        <v-spacer />
        <v-btn
          x-small
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-keyboard-return</v-icon><v-icon>mdi-plus</v-icon>
        </v-btn>
        <!-- <v-btn
            :color="enterpriseColor"
            v-bind="attrs"
            v-on="on"
            dark
          >
            {{$t('common.addContent', locale)}}-
          </v-btn> -->
      </template>
      
      <template v-slot:activator="{ on, attrs }" v-else>
        <!-- dropdownButton add content -->
        <v-btn
            :color="enterpriseColor"
            v-bind="attrs"
            v-on="on"
            dark
            style="margin-left: 10px;"
          >
            {{$t('common.addContent', locale)}}
          </v-btn>
          <v-spacer />
      </template>
      <v-card>
        <!-- <v-card-title>
          <span class="headline">User Profile {{pos}}</span>
        </v-card-title> -->
        <v-card-text>
          <v-layout v-if="!content" wrap>
            <v-flex xs12 style="margin-top:20px;" />
            <v-flex v-for="item in menuTypes" xs3 :key="item.id">
              <div class="btnMenuType" @click="handleSelectMenuType(item.id)">
                <v-icon style="padding: 5px">{{ item.icon }}</v-icon>
                <br>
                <span><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px">{{ $t(`menuType.${item.name}`, locale) }}</h5></span>
              </div>
            </v-flex>
          </v-layout>
        <div
          v-if="content"
          :ref="content.ID"
          style="padding: 0 10px 0 10px !important;"
        >
        <form-title
          v-if="content.Type === 2"
          :content="content"
        />
        <form-space
          v-else-if="content.Type === 3"
          :content="content"
        />
        <form-image
          v-else-if="content.Type === 4"
          :content="content"
        />
        <form-iframe
          v-else-if="content.Type === 5"
          :content="content"
        />
        <form-alert
          v-else-if="content.Type === 6"
          :content="content"
        />
        <form-gallery
          v-else-if="content.Type === 7"
          :content="content"
        />
        <form-video
          v-else-if="content.Type === 8"
          :content="content"
        />
        <form-meteo
          v-else-if="content.Type === 9"
          :content="content"
        />
        <form-map
          v-else-if="content.Type === 10"
          :content="content"
        />
        <form-twitter
          v-else-if="content.Type === 11"
          :content="content"
        />
        <form-facebook
          v-else-if="content.Type === 12"
          :content="content"
        />
        <form-activity
          v-else-if="content.Type === 13"
          :content="content"
        />
        <form-pdf
          v-else-if="content.Type === 14"
          :content="content"
        />
        <form-timeline
          v-else-if="content.Type === 15"
          :content="content"
        />
        <form-text
          v-else-if="content.Type === 16"
          :content="content"
        />
        <form-contact
          v-else-if="content.Type === 17"
          :content="content"
        />
        <form-divider
          v-else-if="content.Type === 18"
          :content="content"
        />
        <form-show
          v-else-if="content.Type === 19"
          :content="content"
        />
        <form-site
          v-else-if="content.Type === 20"
          :content="content"
        />
        <form-agenda
          v-else-if="content.Type === 21"
          :content="content"
        />
        <form-parrilla
          v-else-if="content.Type === 22"
          :content="content"
        />
        <form-wifi
          v-else-if="content.Type === 23"
          :content="content"
        />
        <form-property
          v-else-if="content.Type === 24"
          :content="content"
        />
        <form-commercial
          v-else-if="content.Type === 25"
          :content="content"
        />
        <form-queue
          v-else-if="content.Type === 26"
          :content="content"
        />
        <form-food-drink
          v-else-if="content.Type === 27"
          :content="content"
        />
        <form-link-domain
          v-else-if="content.Type === 28"
          :content="content"
        />
        <form-form
          v-else-if="content.Type === 29"
          :content="content"
        />
        <form-product-service
          v-else-if="content.Type === 30"
          :content="content"
        />
        <form-pdf-translate
          v-else-if="content.Type === 31"
          :content="content"
        />
        <form-link-external
          v-else-if="content.Type === 32"
          :content="content"
        />
        <form-channel-list
          v-else-if="content.Type === 33"
          :content="content"
        />
        <form-activity-acttiv
          v-else-if="content.Type === 34"
          :content="content"
        />
        <form-poll
          v-else-if="content.Type === 35"
          :content="content"
        />
        <form-instagram
          v-else-if="content.Type === 36"
          :content="content"
        />
        <form-icon-list
          v-else-if="content.Type === 37"
          :content="content"
        />
        <form-dropdown-button
          v-else-if="content.Type === 38"
          :content="content"
        />
        <form-dfiles
          v-else-if="content.Type === 39"
          :content="content"
        />

        <form-rcovid
          v-else-if="content.Type === 40"
          :content="content"
        />

        <form-image-translate
          v-else-if="content.Type === 41"
          :content="content"
        />
        <form-iberostar-food
          v-else-if="content.Type === 42"
          :content="content"
        />
        <form-icons
          v-else-if="content.Type === 43"
          :content="content"
        />
        <form-hsconsulting
          v-else-if="content.Type === 44"
          :content="content"
        />

        <form-brochure
          v-else-if="content.Type === 45"
          :content="content"
        />

        <form-infoten
          v-else-if="content.Type === 46"
          :content="content"
        />
            
        <form57InteractiveMaps
          v-else-if="content.Type === 57"
          :content="content"
        />

        <form58AbamaRequestReservation
          v-else-if="content.Type === 58"
          :content="content"
        />

        <availability :data="content" :onChange="handleUpdateAvailability" />
      </div>
          <!-- <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="Legal first name*"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="Legal middle name"
                  hint="example of helper text only on focus"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="Legal last name*"
                  hint="example of persistent helper text"
                  persistent-hint
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Email*"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Password*"
                  type="password"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  :items="['0-17', '18-29', '30-54', '54+']"
                  label="Age*"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  :items="['Skiing', 'Ice hockey', 'Soccer', 'Basketball', 'Hockey', 'Reading', 'Writing', 'Coding', 'Basejump']"
                  label="Interests"
                  multiple
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            {{$t('common.close', locale)}}
          </v-btn>
          <v-btn
            :disabled="!content"
            color="blue darken-1"
            text
            @click="handleSave"
          >
            {{$t('common.save', locale)}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  import api from '@/services/api'
  import utils from '@/services/utils'

  import Availability from '@/components/Availability'
  import FormTitle from './content/Title'
  import FormSpace from './content/Space'
  import FormImage from './content/Image'
  import FormIframe from './content/Iframe'
  import FormAlert from './content/Alert'
  import FormVideo from './content/Video'
  import FormGallery from './content/gallery/Index'
  import FormMeteo from './content/Meteo'
  import FormMap from './content/Map'
  import FormTwitter from './content/Twitter'
  import FormFacebook from './content/Facebook'
  import FormActivity from './content/Activity'
  import FormPdf from './content/PDF'
  import FormTimeline from './content/timeline/Index'
  import FormText from './content/Text'
  import FormContact from './content/contact/Index'
  import FormDivider from './content/Divider'
  import FormShow from './content/Show'
  import FormSite from './content/Site'
  import FormAgenda from './content/Agenda'
  import FormParrilla from './content/Parrilla'
  import FormWifi from './content/Wifi'
  import FormProperty from './content/Property'
  import FormCommercial from './content/Commercial'
  import FormQueue from './content/Queue'
  import FormFoodDrink from './content/foodDrink/Index'
  import FormLinkDomain from './content/LinkDomain'
  import FormForm from './content/FormForm'
  import FormProductService from './content/productService/Index'
  import FormPdfTranslate from './content/PDFTranslate'
  import FormLinkExternal from './content/LinkExternal'
  import FormChannelList from './content/ChannelList'
  import FormActivityActtiv from './content/ActivityActtiv'
  import FormPoll from './content/poll/Index'
  import FormInstagram from './content/Instagram'
  import FormIconList from './content/IconList'
  import FormDropdownButton from './content/dropdownButton/Index'
  import FormDfiles from './content/dfiles/Index'
  import FormRcovid from './content/RCovid'
  import FormImageTranslate from './content/ImageTranslate'
  import FormIberostarFood from './content/IberostarFood'
  import FormIcons from './content/Icons'
  import FormHsconsulting from './content/Hsconsulting'
  import FormBrochure from './content/brochure/Index'
  import FormInfoten from './content/Infoten'
  import Form57InteractiveMaps from './content/Form57InteractiveMaps'
  import Form58AbamaRequestReservation from './content/AbamaRequestReservation'

  export default {
    components: {
      FormTitle,
      Availability,
      FormSpace,
      FormImage,
      FormIframe,
      FormAlert,
      FormGallery,
      FormVideo,
      FormMeteo,
      FormMap,
      FormTwitter,
      FormFacebook,
      FormActivity,
      FormPdf,
      FormTimeline,
      FormText,
      FormContact,
      FormDivider,
      FormShow,
      FormSite,
      FormAgenda,
      FormParrilla,
      FormWifi,
      FormProperty,
      FormCommercial,
      FormQueue,
      FormFoodDrink,
      FormLinkDomain,
      FormForm,
      FormProductService,
      FormPdfTranslate,
      FormLinkExternal,
      FormChannelList,
      FormActivityActtiv,
      FormPoll,
      FormInstagram,
      FormIconList,
      FormDropdownButton,
      FormDfiles,
      FormRcovid,
      FormImageTranslate,
      FormIberostarFood,
      FormIcons,
      FormHsconsulting,
      FormBrochure,
      FormInfoten,
      Form57InteractiveMaps,
      Form58AbamaRequestReservation,
    },
    props: {
      pos: {
        type: Number,
        required: false,
        default: null
      },
      showDialog: {
        type: Boolean,
        required: false,
        default: false
      },
      menuID: { // utilizado para el contenido tipo dropdown button 
        type: String,
        required: false,
        default: null
      }
    },
    data: () => ({
      ord: null,
      dialog: false,
      menuTypes: null,
      content: null
    }),
    computed: {
      ...mapState('app',['locale']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      BGColor () {
        return this.$store.state.app.BGColor
      },
      isCommonMenus () {
        return this.$route.path.split('/')[1] === 'common-menus' ? true : false
      },
    },
    watch: {
      pos (v) {
        this.ord = v
      },
      dialog (v) {
        if (v) {
          this.ord = null
          this.content = null
        }
      }
    },
    created () {
      api.getItem('enterprises', false, this.enterpriseID).then(response => {
        const permission = response.Permission && response.Permission.length > 0 ? JSON.parse(response.Permission) : []    
        this.menuTypes = constants.menuType.filter(x => x.id !== 1 && (permission.indexOf(x.id) !== -1 || this.isCommonMenus))
      })
    },
    methods: {
      handleUpdateAvailability () {

      },
      handleSelectMenuType (id) {
        this.content = utils.getDefaultContentByType(id, this.pos, this.BGColor)
      },
      handleSave () {
        // const editTMP = this.$store.state.app.editTMP
        let { contents, editTMP } = this.$store.state.app

        for (const item of contents) {
          if (item.ORD >= this.pos) item.ORD = item.ORD + 1
        }
        contents.push(this.content)

        contents = contents.sort(function(a, b){
          return a.ORD - b.ORD
        })

        const body = {
          ID: editTMP.ID,
          Name: editTMP.Name,
          Alias: editTMP.Alias,
          ParentID: editTMP.ParentID,
          IsNew: editTMP.isNew,
          IsTemp: editTMP.IsTemp ? true : false,
          StartDate: editTMP.StartDate,
          EndDate: editTMP.EndDate,
          NoEndDate: editTMP.NoEndDate,
          ORD: editTMP.ORD,
          Menus: null,
          Content: contents,
          Type: editTMP.Type,
          Private: editTMP.Private,
          WebAppAsContent: editTMP.WebAppAsContent,
          WebAppAsContentDomain: editTMP.WebAppAsContentDomain,
          BGColor: editTMP.BGColor,
          TextColor: editTMP.TextColor
          // CustomMenuColor: editTMP.CustomMenuColor
        }
        api.updateItem('menus', this.isCommonMenus ? '0000' : this.enterpriseID, body)
          .then(response => {

            // console.log('jhm', response.data.newID)
            api.getAll(`contents/${response.data.newID}`, true, response.data.newID).then(response2 => {
              // console.log('response2', response2)
              this.$store.state.app.contents = response2
              this.dialog = false
            })
            // this.$store.state.app.contents = contents
            // this.$store.state.app.contents
            // this.$store.state.app.isModified = false
            // const isActive =  utils.checkIsActive(this.$store.state.app.editTMP)
            // this.$store.state.app.editTMP.IsActive = isActive
            // // this.onShowMessage(this.$t('menus.messages.update'), 'success')

            // this.$store.state.app.editTMP.noRestore = true // utilizado para fozar que no restaure el BK
            
          })
        
        
        // this.dialog = false
      }      
    }
  }
</script>
<style scoped>
  .btnMenuType {
    text-align: center;
    padding: 10px 0 15px 0;
    font-weight: normal;
    border-radius: 5px;
    width: 100px;
    /* border: 1px solid rgb(197, 197, 197); */
    cursor: pointer;
  }
  .btnMenuType:hover {
    font-weight: 700;
    background-color: rgba(0, 0, 0, 0.1);
  }
</style>
